import { ReactElement, useMemo } from 'react'
import { List, ListItem, ListItemText, Typography, Box } from '@mui/material'
import { InteractionEntry } from 'src/state/stores/ui'

interface Props {
  interactions: InteractionEntry[]
}

const ActivitiesTab = ({ interactions }: Props): ReactElement => {
  const sortedInteractions = useMemo(
    () =>
      [...interactions].sort((a, b) =>
        a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0,
      ),
    [interactions],
  )

  if (sortedInteractions.length === 0) {
    return (
      <Typography variant="body2" color="textSecondary">
        Keine gespeicherten Ereignisse in dieser Sitzung vorhanden.
      </Typography>
    )
  }

  return (
    <List dense>
      {sortedInteractions.map(interaction => (
        <ListItem key={interaction.id} alignItems="flex-start">
          <ListItemText
            primary={
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="subtitle2">{interaction.title}</Typography>
                <Typography
                  variant="caption"
                  color={
                    interaction.state === 'running'
                      ? 'info.main'
                      : interaction.state === 'success'
                      ? 'success.main'
                      : 'error.main'
                  }
                >
                  {interaction.state === 'running'
                    ? 'Läuft'
                    : interaction.state === 'success'
                    ? 'Erfolgreich'
                    : 'Fehlgeschlagen'}
                </Typography>
                <Typography
                  variant="caption"
                  color="textSecondary"
                  sx={{ ml: 1, whiteSpace: 'nowrap' }}
                >
                  {new Date(interaction.createdAt).toLocaleTimeString()}
                </Typography>
              </Box>
            }
            secondary={
              <>
                <Typography variant="body2" color="textSecondary">
                  {interaction.description}
                </Typography>
                {interaction.errorResponse && interaction.state === 'failed' && (
                  <Typography
                    variant="caption"
                    color="error"
                    sx={{ display: 'block', mt: 0.5, whiteSpace: 'pre-wrap' }}
                  >
                    {JSON.stringify(interaction.errorResponse, null, 2)}
                  </Typography>
                )}
              </>
            }
          />
        </ListItem>
      ))}
    </List>
  )
}

export default ActivitiesTab
